// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__245jq","productName":"Table_productName__2Hko6"};